<template src="./PushMessage.html"></template>

<script>
export default {
  data() {
    return {
      dataBody: "",
      dataToMessage: [],
      titlePush: "",
    };
  },
  methods: {
    sendData() {
      this.$store.dispatch("setCargando", true);
      try {
        if (confirm("¡Está seguro de enviar este mensaje!")) {
          this.dataToMessage = {
            template: this.name === null ? "no_aplica" : this.name,
            params: this.selectedParameters,
            type: "text",
            body: this.dataBody,
            title: this.titlePush,
          };
          this.$emit("dataToSend", this.dataToMessage);
        } else {
          this.$store.dispatch("setCargando", false);
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style src="./PushMessage.scss" lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/Mensajes/MensajesUnificado/PushMessage/PushMessage.vue